import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const ONDO_BASE_URL = 'https://app.ondo.finance/api/v2/assets'

// Keys. The `*_GROUP_KEY`s are the **verified** `assetGroup` values from the
// 1delta token list — that is what the lending-market join
// (`intrinsicYields[asset.assetGroup]`) looks up, so they are copied
// character-for-character and must not be "tidied". The list is not
// self-consistent across chains: USDY's group is the bare symbol on
// Ethereum / Mantle / Arbitrum / Sei but name-qualified on BNB and Plume,
// and OUSG's group is name-qualified on Ethereum and Polygon (Flux Finance
// joins through it). Both forms are emitted; the bare keys also serve the
// intrinsic-map consumers keyed by symbol.
//
// These four keys are exhaustive for Ondo (checked 2026-08 against the
// full token-list sweep + Ondo's `/api/v2/assets` index): USDY and OUSG
// are the only yield-accruing Ondo assets — every other Ondo token in our
// lists is a Global Markets tokenized stock/ETF (price tracks the
// underlying, distributions are paid as extra tokens, `apy: null`), USDon
// ("Ondo U.S. Dollar Token") is a plain stablecoin with no API asset
// entry, and rOUSG / wUSDY are absent from our lists. Beware the
// unrelated `USDy` (Optimism/BNB) — different project, not Ondo.
const OUSG_KEY = 'OUSG'
const OUSG_GROUP_KEY = 'Ondo Short-Term US Government Treasuries::OUSG'
const USDY_KEY = 'USDY'
const USDY_GROUP_KEY = 'Ondo US Dollar Yield::USDY'

export const ondoFetcher: YieldFetcher = {
  label: 'ONDO',
  fetch: async () => {
    const [ousgRes, usdyRes] = await Promise.all([
      fetch(`${ONDO_BASE_URL}/ousg/info`).then((r) => r.json()),
      fetch(`${ONDO_BASE_URL}/usdy/info`).then((r) => r.json()),
    ])
    const ousg = apyToAprPercent(Number(ousgRes?.primaryMarket?.apy ?? 0))
    const usdy = apyToAprPercent(Number(usdyRes?.primaryMarket?.apy ?? 0))
    return {
      [OUSG_KEY]: ousg,
      [OUSG_GROUP_KEY]: ousg,
      [USDY_KEY]: usdy,
      [USDY_GROUP_KEY]: usdy,
    }
  },
}
